import {
  afterNextRender,
 computed,
 DestroyRef,
 inject,
 Injectable,
 Signal,
 signal,
 WritableSignal,
} from '@angular/core';
import { SearchBoxService } from './serach-box.service';
import { log } from 'console';
import { todayJalali, tomorrowJalali } from '@core/services/moment.service';

@Injectable({
 providedIn: 'root',
})
export class DatepickerService {
 /*
     - inject
  */
 searchBoxService = inject(SearchBoxService);
 destroyRef = inject(DestroyRef);

 public _allowToShow: WritableSignal<boolean> = signal(true);
 public _customEndDate: WritableSignal<string> = signal('');
 public _customStartDate: WritableSignal<string> = signal('');
 public _disable: WritableSignal<string[]> = signal([]);
  public _endDate: WritableSignal<string> = signal('');
  public _endDateShab: WritableSignal<string> = signal('');
 public _holidays: WritableSignal<string[]> = signal([]);
 public _isMobile: WritableSignal<boolean> = signal(false);
 public _locale: WritableSignal<string> = signal('fa');
 public _maxDate: WritableSignal<string> = signal('');
 public _minDate: WritableSignal<string> = signal('');
 public _nightLimit: WritableSignal<number> = signal(0);
 public _ihoNightLimit: WritableSignal<number> = signal(0);
 public _price: WritableSignal<string[]> = signal([]);
 public _nop: WritableSignal<number> = signal(0);
 public _selectedDate: WritableSignal<string[]> = signal([]);
 public _selectedNights: WritableSignal<string[]> = signal(['']);
  public _startDate: WritableSignal<string> = signal('');
  public _startDateShab: WritableSignal<string> = signal('');
 public _state: WritableSignal<boolean> = signal(false);
 public _unReservable: WritableSignal<string[]> = signal([]);
 public _unReservableBU: WritableSignal<string[]> = signal([]);
 public _weather: WritableSignal<string[]> = signal([]);
 public reservable = signal<boolean>(false);
 public fetchedMonthes: WritableSignal<{ year: number; month: number; index?: number }[]> = signal(
  []
 );
 public ecolodgeCalenderDetails: WritableSignal<boolean | Map<string, any>> = signal(false);
 public isNextMonthLoading: WritableSignal<boolean> = signal(false);
 public isPrevMonthLoading: WritableSignal<boolean> = signal(false);
 public todayJalali: WritableSignal<string> = signal('');
 public tomorrowJalali: WritableSignal<string> = signal('');
 public currentMonth: WritableSignal<string> = signal('');
 public calenderErrors = signal<{ NightLimits: boolean; NonBookable: boolean }>({
  NightLimits: false,
  NonBookable: false,
 });

 constructor() {
  this.setDefaultJalaliDates();
  afterNextRender(() => {
   this.searchBoxService.getCurrentDate().subscribe((res) => {
    const serverDate = res?.Value?.split('T')[0];
    if (serverDate) {
     this.setDefaultJalaliDates(serverDate);
    }
    this.setMinDate(this.todayJalali());
   });

   this.searchBoxService
    .getHolidays({
     StartDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
      .toLocaleDateString('en-GB', { numberingSystem: 'latn' })
      .split('/')
      .reverse()
      .join('-'),
     EndDate: new Date(new Date().getFullYear(), new Date().getMonth() + 12, new Date().getDate())
      .toLocaleDateString('en-GB', { numberingSystem: 'latn' })
      .split('/')
      .reverse()
      .join('-'),
    })
    .subscribe((result) => {
     this.setHolidays(result);
    });
  });
 }

 setDefaultJalaliDates(gregorianDate?: string) {
  this.todayJalali.set(todayJalali(gregorianDate));
  this.tomorrowJalali.set(tomorrowJalali(gregorianDate));
 }

 getDefaultJalaliRange(): [string, string] {
  if (!this.todayJalali() || !this.tomorrowJalali()) {
   this.setDefaultJalaliDates();
  }
  return [this.todayJalali(), this.tomorrowJalali()];
 }

 setAllowToShow(value: boolean) {
  this._allowToShow.set(value);
 }

 setCustomEndDate(value: string) {
  let endDate = '';
  if (value.split(' ')[0].startsWith('0')) {
   endDate = value.split(' ')[0][1] + ' ' + value.split(' ')[1];
  }
  this._customEndDate.set(endDate ? endDate : value);
 }

 setCustomStartDate(value: string) {
  let startDate = '';
  if (value.split(' ')[0].startsWith('0')) {
   startDate = value.split(' ')[0][1] + ' ' + value.split(' ')[1];
  }
  this._customStartDate.set(startDate ? startDate : value);
 }

 setDisable(value: string[]) {
  this._disable.set(value);
 }

 setEndDate(value: string) {
  const monthArray = [
   '',
   'فروردین',
   'اردیبهشت',
   'خرداد',
   'تیر',
   'مرداد',
   'شهریور',
   'مهر',
   'آبان',
   'آذر',
   'دی',
   'بهمن',
   'اسفند',
  ];
  this.searchBoxService.dateRange[1] = value;
  this._endDate.set(value);
  let startDate = '';
  let startMonth = '';
  if (value !== '') {
   if (value.split('/')[2].startsWith('0')) {
    startDate = value.split('/')[2][1];
   }
   if (value.split('/')[1].startsWith('0')) {
    startMonth = value.split('/')[1][1];
   }
   this._customEndDate.set(
    `${startDate ? startDate : value.split('/')[2]} ${
     startMonth ? monthArray[+startMonth] : monthArray[+value.split('/')[1]]
    }`
   );
  }
 }
  setEndDateShab(value: string) {
    const monthArray = [
      '',
      'فروردین',
      'اردیبهشت',
      'خرداد',
      'تیر',
      'مرداد',
      'شهریور',
      'مهر',
      'آبان',
      'آذر',
      'دی',
      'بهمن',
      'اسفند',
    ];
    this.searchBoxService.dateRange[1] = value;
    this._endDateShab.set(value);
    let startDate = '';
    let startMonth = '';
    if (value !== '') {
      if (value.split('/')[2].startsWith('0')) {
        startDate = value.split('/')[2][1];
      }
      if (value.split('/')[1].startsWith('0')) {
        startMonth = value.split('/')[1][1];
      }
      this._customEndDate.set(
        `${startDate ? startDate : value.split('/')[2]} ${startMonth ? monthArray[+startMonth] : monthArray[+value.split('/')[1]]
        }`
      );
    }
  }
 setHolidays(dates: string[]) {
  this._holidays.set(dates);
 }

 setIsMobile(value: boolean) {
  this._isMobile.set(value);
 }

 setLocale(value: string) {
  this._locale.set(value);
 }

 setMaxDate(value: string) {
  this._maxDate.set(value);
 }

 setMinDate(value: string) {
  this._minDate.set(value);
 }

 setNightLimit(value: number) {
  this._nightLimit.set(value);
 }

 setPrice(value: string[]) {
  this._price.set(value);
 }

 setNop(value: number) {
  this._nop.set(value);
 }

 setCalenderDetails(calenderDetails: any) {
  if (!this.fetchedMonthes().length) {
   this.fetchedMonthes.set([
    { year: +this._startDate().split('/')[0], month: +this._startDate().split('/')[1] },
    {
     year:
      +this._endDate().split('/')[1] == 12
       ? +this._startDate().split('/')[0] + 1
       : +this._endDate().split('/')[0],
     month: +this._endDate().split('/')[1] == 12 ? 1 : +this._endDate().split('/')[1] + 1,
    },
   ]);
  }

  this.isNextMonthLoading.set(false);
  this.isPrevMonthLoading.set(false);


  this.ecolodgeCalenderDetails.set(calenderDetails);
 }

 setSelectedDate(value: string[]) {
  this._selectedDate.set(value);
 }

 setSelectedNights(value: string[]) {
  this._selectedNights.set(value);
 }

 setStartDate(value: string) {
  
  const monthArray = [
   '',
   'فروردین',
   'اردیبهشت',
   'خرداد',
   'تیر',
   'مرداد',
   'شهریور',
   'مهر',
   'آبان',
   'آذر',
   'دی',
   'بهمن',
   'اسفند',
  ];
  this.searchBoxService.dateRange[0] = value;
  this._startDate.set(value);
  let startDate = '';
  let startMonth = '';
  if (value !== '') {
   if (value.split('/')[2].startsWith('0')) {
    startDate = value.split('/')[2][1];
   }
   if (value.split('/')[1].startsWith('0')) {
    startMonth = value.split('/')[1][1];
   }
   this._customStartDate.set(
    `${startDate ? startDate : value.split('/')[2]} ${
     startMonth ? monthArray[+startMonth] : monthArray[+value.split('/')[1]]
    }`
   );
  }

 }
  setStartDateShab(value: string) {
    const monthArray = [
      '',
      'فروردین',
      'اردیبهشت',
      'خرداد',
      'تیر',
      'مرداد',
      'شهریور',
      'مهر',
      'آبان',
      'آذر',
      'دی',
      'بهمن',
      'اسفند',
    ];
    this.searchBoxService.dateRange[0] = value;
    this._startDateShab.set(value);
    let startDate = '';
    let startMonth = '';
    if (value !== '') {
      if (value.split('/')[2].startsWith('0')) {
        startDate = value.split('/')[2][1];
      }
      if (value.split('/')[1].startsWith('0')) {
        startMonth = value.split('/')[1][1];
      }
      this._customStartDate.set(
        `${startDate ? startDate : value.split('/')[2]} ${startMonth ? monthArray[+startMonth] : monthArray[+value.split('/')[1]]
        }`
      );
    }

  }

 setState(value: boolean) {
  this.setUnReservable([]);
  this._state.set(value);
 }

 setUnReservable(value: string[], status = false) {
  this._unReservable.set(value);
  if (status) {
   this._unReservableBU.set(value);
  }
 }

 setWeather(value: string[]) {
  this._weather.set(value);
 }

 isDateNormalized(date: string): boolean {
  const [_, month, day] = date.split('/');
  return month.length === 2 && day.length === 2;
  }

  normalizeDate(date: string): string {
    const [year, month, day] = date.split('/');
    const paddedMonth = month.padStart(2, '0');
    const paddedDay = day.padStart(2, '0');
    return `${year}/${paddedMonth}/${paddedDay}`;
  }

}
